import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P15-E1",
    audio: "img/FriendsPlus/Page14/Audio/audio-e3-p14.mp3",
    video: "Videos/e3.p14.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [{ url: "img/FriendsPlus/Page15/E1/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page14/E3/4.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh1-e3-p14.mp3", },
        { url: "img/FriendsPlus/Page14/E3/5.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh2-e3-p14.mp3", },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page14/E3/6.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh3-e3-p14.mp3", },
        { url: "img/FriendsPlus/Page14/E3/7.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh4-e3-p14.mp3", },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page14/E3/8.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh5-e3-p14.mp3", },
        { url: "img/FriendsPlus/Page14/E3/9.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh6-e3-p14.mp3", },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 1",
    id: "SB1-U1-P15-E2",
    audio: "img/FriendsPlus/Page15/Audio/audio-e2-p15.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page15/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page15/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page15/Audio/tieude-e2-p15.mp3",
        },
        { url: "img/FriendsPlus/Page15/E2/3.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page15/E2/4.jpg" },
        {
          url: "img/FriendsPlus/Page15/E2/5.jpg",
          audioUrl: "img/FriendsPlus/Page15/Audio/hinh1-e2-p15.mp3",
        },
        { url: "img/FriendsPlus/Page15/E2/6.jpg" },
        {
          url: "img/FriendsPlus/Page15/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page15/Audio/hinh2-e2-p15.mp3",
        },
        { url: "img/FriendsPlus/Page15/E2/8.jpg" },
        {
          url: "img/FriendsPlus/Page15/E2/9.jpg",
          audioUrl: "img/FriendsPlus/Page15/Audio/hinh3-e2-p15.mp3",
        },
        { url: "img/FriendsPlus/Page15/E2/10.jpg" },
        {
          url: "img/FriendsPlus/Page15/E2/11.jpg",
          audioUrl: "img/FriendsPlus/Page15/Audio/hinh5-e2-p15.mp3",
        },
        { url: "img/FriendsPlus/Page15/E2/12.jpg" },
      ],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P15-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page15/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P15-E4",
    audio: "",
    video: "",
    component: D1,
    exerciseKey: "img/FriendsPlus/Page15/E4/Key/answerKey.png",
    isAllowSubmit: false,
    questionImage: [
      [{ url: "img/FriendsPlus/Page15/E4/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page15/E4/2.jpg" },
        { url: "img/FriendsPlus/Page15/E4/3.jpg", input: true, answer: "This" },
        { url: "img/FriendsPlus/Page15/E4/4.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page15/E4/5.jpg" }],
      [
        // Column4
        { url: "img/FriendsPlus/Page15/E4/6.jpg" },
        { url: "img/FriendsPlus/Page15/E4/7.jpg", input: true, answer: "These" },
        { url: "img/FriendsPlus/Page15/E4/8.jpg" },
        { url: "img/FriendsPlus/Page15/E4/9.jpg", input: true, answer: "That" },
        { url: "img/FriendsPlus/Page15/E4/10.jpg" },
      ],
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P15-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page15/E5/1.jpg" }]],
  },
};

export default json;
